import { render } from "./ScrollProgress.vue?vue&type=template&id=fa4fb822"
import script from "./ScrollProgress.vue?vue&type=script&lang=js"
export * from "./ScrollProgress.vue?vue&type=script&lang=js"
script.render = render

export default script